import { Component, OnInit } from 'angular-ts-decorators';

import {
  faExclamationCircle,
  faExclamationTriangle,
} from '@fortawesome/pro-solid-svg-icons';
import { SyncRequests } from '../../services/sync-requests';

/**
 * Component shows and syncs offline requests
 *
 * # Example
 * <pre>
 *   <sw-sync-requests></sw-sync-requests>
 * </pre>
 */
@Component({
  selector: 'swSyncRequests',
  template: require('./sw-sync-requests.html').default,
})
export class SwSyncRequestsComponent implements OnInit {
  faExclamationTriangle = faExclamationTriangle;
  faExclamationCircle = faExclamationCircle;
  count = 0;
  max = 0;
  syncProcessStarted = false;
  value = 0;
  requests = [];
  failed = [];

  constructor(
    private $timeout: ng.ITimeoutService,
    private syncRequests: SyncRequests,
  ) {
    'ngInject';
  }

  private handlePendingRequests(event) {
    if (event.data.request) {
      this.requests.push(event.data.request);
    }
    if (this.syncProcessStarted) {
      this.max = this.count;
      let value = this.max - event.data.count;

      this.$timeout(() => {
        this.value = value;
        this.requests.pop();
        if (this.max === value) {
          this.$timeout(() => {
            this.syncProcessStarted = false;
            this.count = 0;
          }, 500);
        }
      }, 100);
    } else {
      this.count = event.data.count;
    }
  }

  private handleStartSyncProcess(event) {
    if (event.data.count > 0) {
      this.syncProcessStarted = true;
      this.count = event.data.count;
    }
  }

  private handleFailedRequest(event) {
    this.failed.push(event.data.request);
    this.count = event.data.count;
  }

  private updateAllRequests(event) {
    this.failed = event.data.failed;
    this.requests = event.data.requests;
    this.count = event.data.count;
  }

  ngOnInit() {
    this.syncRequests.startServiceWorkerEvents((event) => {
      this.handleMessages(event);
    });
  }

  openStatusModal(showState) {
    this.syncRequests.openStatusModal(showState, this.requests, this.failed);
  }

  handleMessages(event) {
    switch (event.data.msg) {
      case 'update-all-requests':
        return this.updateAllRequests(event);
      case 'update-pending-requests':
        return this.handlePendingRequests(event);
      case 'failed-request':
        return this.handleFailedRequest(event);
      case 'start-sync-process':
        return this.handleStartSyncProcess(event);
    }
  }
}
